import styled from "styled-components";

type BadgeVariant = "info" | "error" | "warning";

const getBadgeBackground = (active: boolean, variant: BadgeVariant): string => {
    if (!active) return "#333";

    switch (variant) {
        case "error":
            return "#d32f2f";
        case "warning":
            return "#f57c00";
        default:
            return "#1976d2";
    }
};

export const Container = styled.div`
    position: fixed;
    bottom: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.85);
    color: #fff;
    padding: 12px;
    border-radius: 6px;
    font-size: 11px;
    font-family: monospace;
    line-height: 1.4;
    z-index: 99999;
    width: 220px;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    border-bottom: 1px solid #444;
    padding-bottom: 6px;
`;

export const Title = styled.span`
    font-weight: bold;
    font-size: 12px;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    color: #888;
    cursor: pointer;
    font-size: 14px;
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
`;

export const Label = styled.span`
    color: #888;
`;

export const Section = styled.div`
    margin-top: 8px;
`;

export const SectionTitle = styled.div`
    color: #4fc3f7;
    font-weight: bold;
    margin-bottom: 4px;
`;

export const Badge = styled.span<{ $active: boolean; $variant: BadgeVariant }>`
    display: inline-block;
    padding: 1px 5px;
    border-radius: 3px;
    margin-right: 4px;
    font-size: 10px;
    background: ${({ $active, $variant }) => getBadgeBackground($active, $variant)};
    color: ${({ $active }) => ($active ? "#fff" : "#666")};
`;
